import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { useOpponentsVideo } from '@gem/call/CallView/hooks/useOpponentsVideo/useOpponentsVideo';
import { customScrollStyles } from '@gem/ui-kit';

import { OpponentsView } from '../OpponentsView/OpponentsView';
import styles from './OpponentList.styles.m.css';

export const OpponentList = observer(() => {
  const { opponentsKeys } = useOpponentsVideo();

  return (
    <div className={classNames(styles.container, customScrollStyles.container)}>
      <OpponentsView opponentsKeys={opponentsKeys} />
    </div>
  );
});
